/**
 * @ngdoc directive
 * @name drvFromAddressPreview
 * 
 * @description
 * Used for displaying the from address of an email
 *
 * @param {object} email - The from address will be displayed for the supplied email.
 * @param {string} currentEntityName - There is situations where the email will not yet have a related entity.
 *                                      In these situations the currentEntityName will be used when 'CurrentEntity' is selected.
 *
 */

(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmailFromAddressPreview', drvEmailFromAddressPreview);

    drvEmailFromAddressPreview.$inject = [];

    function drvEmailFromAddressPreview() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvEmailFromAddressPreviewCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                email: '=',
                currentEntityName: '='
            },
            template:
                '<div class="error-messsage-div page-content" ng-if="drvCtrl.error">' +
                '   {{drvCtrl.error}}' +
                '</div>' +
                '<md-progress-circular ng-if="drvCtrl.loading"></md-progress-circular>' +
                '<span ng-if="!drvCtrl.error && !drvCtrl.loading">{{drvCtrl.fromAddressPreview}}</span>'
        };

        drvEmailFromAddressPreviewCtrl.$inject = ['$scope', 'EntitiesService', 'ChilliUserProfileService'];

        return directive;

        function drvEmailFromAddressPreviewCtrl($scope, EntitiesService, ChilliUserProfileService) {
            /* jshint validthis:true */
            var drvCtrl = this;
            drvCtrl.loading = true;

            activate();

            function activate() {
                if (!_.isNil(drvCtrl.email) && !_.isNil(drvCtrl.email.data)) {
                    getFromAddressPreview();
                } else {
                    drvCtrl.loading = false;
                }

                $scope.$watch('drvCtrl.email.data.FromAddressOverrideEntityId', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        getFromAddressPreview();
                    }
                });
            }

            /**
             * Sets the preview value for the from address details held on the email.
             */
            function getFromAddressPreview() {
                drvCtrl.loading = true;
                drvCtrl.error = null;

                if (_.isNil(drvCtrl.email) || _.isNil(drvCtrl.email.data) || _.isNil(drvCtrl.email.data.FromAddressOverrideEntityId) || drvCtrl.email.data.FromAddressOverrideEntityId === '') {
                    drvCtrl.loading = false;
                    drvCtrl.fromAddressPreview = '';
                } else {
                    if (_.isNil(getFromAddressPreview['Entity' + drvCtrl.email.data.FromAddressOverrideEntityId])) {
                        loadEntity(drvCtrl.email.data.FromAddressOverrideEntityId);
                        } else {
                        drvCtrl.fromAddressPreview = getFromAddressPreview['Entity' + drvCtrl.email.data.FromAddressOverrideEntityId];
                            drvCtrl.loading = false;
                        }
                    }
                }

            function loadEntity(entityId) {
                EntitiesService.getPreviewText(entityId)
                        .then(getCurrentEntityOk, getCurrentEntityError);

                function getCurrentEntityOk(data) {
                    getFromAddressPreview['Entity' + entityId] = data.EntityTemplateName + ' - ' + data.PreviewNameText;
                    drvCtrl.fromAddressPreview = getFromAddressPreview['Entity' + entityId];
                    drvCtrl.loading = false;
                }

                function getCurrentEntityError(error) {
                    drvCtrl.error = error;
                    drvCtrl.loading = false;
                }
            }
        }
    }
})();